import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { IconTypes } from '@eika/icon';
import { Link } from '@eika/link';
import { Modal } from '@eika/modal';

import { meldSkadeNamespace } from '../../index';
import { AppState } from '../../reducers';
import { DateAsString } from '../../types/generated-types';

type RouteToFremtindInfoAndModalProps = {
    shouldRouteKundeToFremtind: boolean;
    skadedato: DateAsString;
    openModal: boolean;
    setOpenModal: (open: boolean) => void;
};

const RouteToFremtindInfoAndModal = ({
    shouldRouteKundeToFremtind,
    skadedato,
    openModal,
    setOpenModal,
}: RouteToFremtindInfoAndModalProps) => {
    const { fremtindUrl } = useSelector((state: AppState) => state.skademelding);

    useEffect(() => {
        setOpenModal(shouldRouteKundeToFremtind);
    }, [shouldRouteKundeToFremtind, skadedato, setOpenModal]);

    return (
        <>
            <p>
                Nettsiden du er på nå, driftes fortsatt av tidligere Eika Forsikring, og forsikringen din er flyttet.
                Hvis denne datoen er riktig, må du{' '}
                <Link icon={IconTypes.EKSTERN_24} href={fremtindUrl} linkType="inline">
                    melde skaden hos Fremtind
                </Link>
                .
            </p>
            <Modal
                appNamespace={meldSkadeNamespace}
                open={openModal}
                setOpen={setOpenModal}
                onClose={() => setOpenModal(false)}
            >
                <h2>Forsikringen din er flyttet til Fremtind</h2>
                <p>
                    Denne nettsiden driftes fortsatt av tidligere Eika Forsikring, men forsikringen din er nå hos
                    Fremtind.
                </p>
                <p>Derfor må du melde skaden i Fremtind sine systemer.</p>
                <p>Vi sender deg videre, så du får meldt skaden på riktig sted.</p>
                <div className="center">
                    <Link href={fremtindUrl} linkType="button-positive" icon={IconTypes.EKSTERN_24}>
                        Meld skade hos Fremtind
                    </Link>
                </div>
            </Modal>
        </>
    );
};

export default RouteToFremtindInfoAndModal;
